<template>
  <div class="licorice-sns-base" :class="{onlyTwitter: onlyTwitter}">
    <div class="head-img" v-if="!onlyTwitter"><img src="/static/img/licorice/share/ttl_share.png"></div>
    <div class="buttons">
      <div class="wrap">
        <a :href="info_twitter.url" target="_blank" class="shareButton-twitter" @click="sendGaEvent(info_twitter.galabel, $event)"><img src="/static/img/licorice/share/btn_tw.png" alt=""></a>
        <a v-if="!onlyTwitter" :href="info_line.url" target="_blank" class="shareButton-line" @click="sendGaEvent(info_line.galabel, $event)"><img src="/static/img/licorice/share/btn_line.png" alt=""></a>
        <a v-if="!onlyTwitter" :href="info_facebook.url" target="_blank" class="shareButton-facebook" @click="sendGaEvent(info_facebook.galabel, $event)"><img src="/static/img/licorice/share/btn_fb.png" alt=""></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SnsLicorice",
  data() {
    return {
      defSharedata: {
        twitter: {
          url: 'http://twitter.com/share?url=https://uranai.tv/lp/movie/licorice?cpno=990000000102&text=__SHARETEXT__%0a',
          text: '自分と同じ誕生日の主人公が登場する%0a心にそっと寄り添う等身大の物語%0a%0a%23リコリス%0a占い監修：%23鏡リュウジ%0a物語：%23カツセマサヒコ%0a絵：%23ますだみく、他',
          galabel: 'twitter_licorice'
        },
        line: {
          url: 'http://line.me/R/msg/text/?__SHARETEXT__%0ahttps://uranai.tv/lp/movie/licorice?cpno=990000000103',
          text: '自分と同じ誕生日の主人公が登場する\n心にそっと寄り添う等身大の物語\n\nLicorice -リコリス-\n占い監修：鏡リュウジ\n物語：カツセマサヒコ\n絵：ますだみく、他',
          galabel: 'line_licorice'
        },
        facebook: {
          url: 'http://www.facebook.com/share.php?u=https://uranai.tv/lp/movie/licorice?cpno=990000000104',
          galabel: 'facebook_licorice'
        },
      }
    }
  },
  props: {
    sharedata: {
      type: Object,
      default: {
        twitter: {
          url: '',
          text: '',
          galabel: ''
        },
        line: {
          url: '',
          text: '',
          galabel: ''
        },
        facebook: {
          url: '',
          text: '',
          galabel: ''
        }
      }
    },
    onlyTwitter: {
      type: Boolean,
      default(){
        return false
      }
    }
  },
  computed: {
    info_twitter () {
      let res = {}
      const receive = this.sharedata.twitter
      const def = this.defSharedata.twitter
      if ( receive.url != null && receive.url.length > 0 ) {
        res.url = receive.url
      } else {
        let txt = decodeURI(receive.text)
        res.url = def.url.replace(/__SHARETEXT__/, receive.text != null && receive.text.length > 0 ? txt : def.text)
      }
      if ( receive.galabel != null && receive.galabel.length > 0 ) {
        res.galabel = receive.galabel
      } else {
        res.galabel = def.galabel
      }
      return res
    },
    info_line () {
      let res = {}
      const receive = this.sharedata.line
      const def = this.defSharedata.line
      if ( receive.url != null && receive.url.length > 0 ) {
        res.url = receive.url
      } else {
        let txt = decodeURI(receive.text)
        res.url = def.url.replace(/__SHARETEXT__/, receive.text != null && receive.text.length > 0 ? txt : encodeURI(def.text) )
      }
      if ( receive.galabel != null && receive.galabel.length > 0 ) {
        res.galabel = receive.galabel
      } else {
        res.galabel = def.galabel
      }
      return res
    },
    info_facebook () {
      let res = {}
      const receive = this.sharedata.facebook
      const def = this.defSharedata.facebook
      if ( receive.url != null && receive.url.length > 0 ) {
        res.url = receive.url
      } else {
        res.url = def.url
      }
      if ( receive.galabel != null && receive.galabel.length > 0 ) {
        res.galabel = receive.galabel
      } else {
        res.galabel = def.galabel
      }
      return res
    },
  },
  methods: {
    sendGaEvent (label){
      window.gtag('event', 'click', {'event_category': 'result_share', 'event_label': label})
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../sass/variables/index';
.licorice-sns-base {
  .head-img {
    width: 100%;
    background: linear-gradient(to bottom, rgba(229,224,224,1) 0%,rgba(229,224,224,1) 60%,rgba(199,218,236,1) 61%,rgba(199,218,236,1) 100%);
    padding-bottom: 4px;
    img {
      width: 100%;
      display: block;
    }
  }
  .buttons {
    width: 100%;
    padding: 0 0 24px;
    text-align: center;
    background: #C7DAEC;
    .wrap {
      margin: 0 auto;
      position: relative;
      width: 275px;
      height: 98px;
      @include mq ('w320') {
        width: 311px;
        height: 108px;
      }
      a {
        display: block;
        height: 43px;
        position: absolute;
        @include mq ('w320') {
          height: 48px;
        }

        &.shareButton-twitter {
          top: 0;
          left: 0;
          width: 275px;
          @include mq ('w320') {
            width: 311px;
          }
        }

        &.shareButton-line {
          bottom: 0;
          left: 0;
          width: 132px;
          @include mq ('w320') {
            width: 150px;
          }
        }

        &.shareButton-facebook {
          bottom: 0;
          right: 0;
          width: 132px;
          @include mq ('w320') {
            width: 150px;
          }
        }
        img {
          display: block;
          width: 100%;
        }
      }
    }
  }
  &.onlyTwitter {
    .buttons {
      padding: 0;
      background: none;
      .wrap {
        height: 98px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SnsLicorice.vue